module.exports = __webpack_public_path__ + "img/Merci_hubert_by_oliverlist.f0aa752b.png";